export default __webpack_public_path__ + "787d7a3f7ec3a8eea784d8c013e3eb8f.png";